import React, { useState, useEffect, Component } from "react";
import offerPath from "../../data/public_offer.md"
import ReactMarkdown from 'react-markdown';
import Header from "../../components/Header";
import "./Document.css"


class PublicOffer extends Component {

    constructor(props) {
        super(props)
    
        this.state = { terms: null }
      }
    
      componentWillMount() {
        fetch(offerPath).then((response) => response.text()).then((text) => {
          this.setState({ terms: text })
        })
      }
    
      render() {
        return (
        <div className="app">
            <Header />
            <main className="document_body">
                <div>
                    <ReactMarkdown >
                        {this.state.terms}
                        {/* {"rgegr"} */}
                    </ReactMarkdown>
                </div>
            
            </main>
        </div>
        )
      }
}


export default PublicOffer;
